import React from 'react';
import PropTypes from 'prop-types';
import { contentfulViews, contentfulModels, components } from '@glowforge/ui-common';

import { FeaturesDisplayWidget } from 'app/common/components/features-display';
import MeetTheFamily from './meet-the-family';
import CallToActionBanner from './call-to-action-banner';
import MediaCardsList from './media-cards-list';
import SocialCards from './social-cards';
import MaterialsDisplayWidget from './materials-display-widget';
import MaterialsCarousel3dWidget from './materials-carousel-3d-widget';
import MessageBanner from './message-banner';

import './glowforge-landing-page.less';

const { pagePropType } = contentfulModels;
const { Page } = contentfulViews;
const { MadLibProvider } = components;

class GlowforgeLandingPage extends React.Component {
  componentDidMount() {
    // Analytics calls to track new homepage
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'new_homepage' });
    const FS = window.FS;
    if (FS && typeof FS.event === 'function') {
      FS.event('new_homepage');
    }
  }

  render() {
    const {
      referralInfo,
      products,
      page,
    } = this.props;
    const customSections = {
      'meet-the-family': { component: MeetTheFamily },
      'call-to-action': { component: CallToActionBanner },
      'media-cards-list': { component: MediaCardsList },
      'social-cards': { component: SocialCards },
      'materials-display': { component: MaterialsDisplayWidget },
      'materials-carousel-3d': { component: MaterialsCarousel3dWidget },
      'features-display': { component: FeaturesDisplayWidget },
      'message-banner': {
        component: MessageBanner,
        props: {
          referralInfo,
          products,
        },
      },
    };

    const attributions = {
      referralCode: referralInfo ? referralInfo.referralCode : null,
      promoLink: referralInfo ? referralInfo.promoLink : null,
    };

    return (
      <MadLibProvider attributions={attributions} >
        <Page
          className='GlowforgeLandingPage'
          {...page}
          title={null}
          customSections={customSections} />
      </MadLibProvider>
    );
  }
}

GlowforgeLandingPage.propTypes = {
  page: PropTypes.shape(pagePropType),
  products: PropTypes.shape({}),
  referralInfo: PropTypes.shape({
    referralCode: PropTypes.string,
    promoLink: PropTypes.string,
  }),
};

GlowforgeLandingPage.defaultProps = {
  page: {
    sections: [],
  },
  products: null,
  referralInfo: null,
};

export default GlowforgeLandingPage;



// WEBPACK FOOTER //
// ./app/components/landing/glowforge-landing-page.jsx